import { Provider, provideAppInitializer } from '@angular/core';
import type { TranslateModuleConfig } from '@ngx-translate/core';
import { MissingTranslationHandler, TranslateLoader } from '@ngx-translate/core';

import { CustomMissingTranslationHandler } from '@common/handlers/missing-translations.handler';

export function createTranslationModuleConfig(
    factory: (...args: any[]) => TranslateLoader,
    dependencies: any[]
): TranslateModuleConfig {
    return {
        missingTranslationHandler: {
            provide: MissingTranslationHandler,
            useClass: CustomMissingTranslationHandler,
        },
        loader: {
            provide: TranslateLoader,
            useFactory: factory,
            deps: dependencies,
        },
    };
}
